import { VideoProject } from "@/services/bedrock";

export function isQaReviewStatus(status?: string | null): boolean {
  return status === VideoProject.Status.SUBMITTED_FOR_QA_REVIEW || status === VideoProject.Status.QA_REVIEW;
}

export function isQaStudioReadOnly(status?: string | null, archived?: boolean | null): boolean {
  return !!archived || status !== VideoProject.Status.QA_REVIEW;
}

export function shouldWarnSelfQa(currentUserId?: number | null, editorUserId?: number | null): boolean {
  return currentUserId != null && editorUserId != null && currentUserId === editorUserId;
}
